import { render, staticRenderFns } from "./EmpleadoLayout.vue?vue&type=template&id=493a6dec&"
import script from "./EmpleadoLayout.vue?vue&type=script&lang=js&"
export * from "./EmpleadoLayout.vue?vue&type=script&lang=js&"
import style0 from "./EmpleadoLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports